import InfoAndSlideShow from "../components/Sections/InfoAndSlideShow";
import { Helmet } from "react-helmet";

const AboutUs = () => {
    return (
        <div>
            <Helmet>
                <title>About Us</title>
            </Helmet>
            <div className="flex flex-col items-center justify-center pt-28 pb-20">
                <div className="font-poppins text-5xl text-primary-blue font-extralight pt-12">
                    About Us
                </div>
                <div className="flex flex-col items-center justify-center w-screen">
                    <div className="font-poppins text-2xl text-primary-blue pt-9 font-extralight text-center w-[80%]">
                        Welcome to Sultana Homes, where affordable luxury meets
                        exceptional living.{" "}
                    </div>
                    <div className="font-poppins text-2xl text-primary-blue pt-14 font-extralight text-center w-[80%]">
                        With over 40+ years of experience in construction and
                        real estate development, we bring global expertise to
                        Pakistan, delivering superior homes in exceptionally
                        chosen well-connected locations.
                    </div>
                </div>
            </div>
            <InfoAndSlideShow section={3}/>
            <InfoAndSlideShow section={4}/>
            <InfoAndSlideShow section={5}/>
            <InfoAndSlideShow section={6}/>
        </div>
    );
};

export default AboutUs;
